import { render, staticRenderFns } from "./ReportSalesAveragesPage.vue?vue&type=template&id=6dbab64e&scoped=true"
import script from "./ReportSalesAveragesPage.vue?vue&type=script&lang=js"
export * from "./ReportSalesAveragesPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dbab64e",
  null
  
)

export default component.exports